import type { CommandDeckPreviewBundle, CommandDeckSurfaceMode } from '../contracts/types'

interface Props {
  bundle: CommandDeckPreviewBundle
  mode: CommandDeckSurfaceMode
  onOpenSettings: () => void
}

function initials(name: string): string {
  const parts = name.trim().split(/\s+/).filter(Boolean)
  if (parts.length === 0) return 'ST'
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase()
  return `${parts[0][0] ?? ''}${parts[1][0] ?? ''}`.toUpperCase()
}

export function CommandDeckIdentityHub({ bundle, onOpenSettings }: Props) {
  const { identity } = bundle.personalization
  const name = identity.displayName

  return (
    <header className="cd-mc-identity cd-mc-identity--compact command-deck-glass">
      <div className="cd-mc-identity__avatar" aria-hidden="true">
        {initials(name)}
      </div>
      <div className="cd-mc-identity__body">
        <p className="cd-mc-identity__name">{name}</p>
        <p className="cd-mc-identity__role">
          {identity.roleDisplayLabel} ·{' '}
          <span className="cd-mc-identity__access">{identity.accessLabel}</span>
        </p>
      </div>
      <p className="cd-mc-identity__status" aria-label="Operational status">
        {identity.operationalStatus}
      </p>
      <button
        type="button"
        className="cd-mc-settings-trigger"
        onClick={onOpenSettings}
        aria-label="Open Command Deck settings"
      >
        Settings
      </button>
    </header>
  )
}
